module.exports = __webpack_public_path__ + "graphics/checkout-coupon-background.ckh.fdd59047f2a530de7f729422433d01ab.svg";